export const errorDebounceMillis = 500;
export class ResolveCrashError extends Error {
    constructor(message) {
        super(message);
        this.name = 'ResolveCrashError';
    }
}
